import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateUserStatus = ({ userID, status }) => {
  try {
    return axios.put(
      `/api/contacts/${userID}/status`,
      JSON.stringify({ Status: status })
    );
  } catch (error) {
    return error;
  }
};

export const useUpdateUserStatus = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateUserStatus,
    onSuccess: () => {
      enqueueSnackbar('Contact status successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
